import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-midnight flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 tech-grid-bg" />
      <div className="relative text-center">
        <div className="overline mb-4">404 · NOT FOUND</div>
        <h1 className="font-display font-black tracking-tighter text-white text-7xl md:text-9xl mb-6 uppercase">
          Lost route
        </h1>
        <p className="text-white/65 mb-8 max-w-md mx-auto">
          Кажется, такой страницы нет. Вернитесь на главную.
        </p>
        <Link to="/" className="btn-primary !py-4 !px-7">
          На главную
        </Link>
      </div>
    </div>
  );
}
